export default {
  documentTitle:
    "Hardware wallet -Your key's pal to guarantee Crypto assets | KeyPal",
  product: 'Product',
  learn: 'Learn',
  support: 'Support',
  others: 'Others',
  language: 'Language',
  forBusiness: 'Business',
  apps: 'Apps',
  secretBox: 'Secret Box',
  learnMore: 'Learn More', 
  goShoppingCart: 'Go to Store', 
  contactUs: 'Contact Us:', 
  tutorials: 'Tutorials', 
  mobileWallet: 'Mobile Wallet', 
  extensionWallet: 'Extension Wallet', 
  cases: 'Cases:', 
  cooperationSolution: 'Business Cooperation', 
  information: 'Information', 
  security: 'Security', 
  darkMode: 'Dark Mode',
  KeyPal_2_firmware: 'KeyPal 2 Firmware', 
  KeyPal_Plus_firmware: 'KeyPal Plus Firmware', 
  more: 'and more...',
  comingSoon: 'Coming soon',
}
